module.exports = __webpack_public_path__ + "static/media/laxmirajmokuf6.7b4d8d78.png";